export default function useQueryParams(){
    const urlParams = new URLSearchParams(window.location.search);
    const keyValueMap = {};
    for(const [key,value] of urlParams) {
        keyValueMap[key] = value
    }
    return keyValueMap;
}

